var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTop)?_c('a',{staticClass:"backtop",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.backtop}},[_vm._v("Top")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }